<carvector-layout [menu]="menu">
  <router-outlet></router-outlet>
</carvector-layout>
